import { render, staticRenderFns } from "./LimpezaPonto.vue?vue&type=template&id=ed433cf4&scoped=true&"
import script from "./LimpezaPonto.vue?vue&type=script&lang=js&"
export * from "./LimpezaPonto.vue?vue&type=script&lang=js&"
import style0 from "./LimpezaPonto.vue?vue&type=style&index=0&id=ed433cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed433cf4",
  null
  
)

export default component.exports